import _ from 'lodash';

import { API_V2_MODEL_NAMES } from './modelTypes';

export const API_TRACKING_HEADER = 'x-pi-tracking' as const;

/**
 * All model names from both api v1 and api-v2
 */
export const MODEL_NAMES = _.uniq([...API_V2_MODEL_NAMES]).sort();

export const OP_FIND_PARAMS = [
    'limit',
    'populate',
    'query',
    'select',
    'skip',
    'sort',
    'virtuals',
] as const;

export const OP_FIND_POST_PARAMS = [...OP_FIND_PARAMS, 'queryListVariables'] as const;

export const OP_FIND_ONE_PARAMS = ['query', 'select', 'sort', 'populate', 'virtuals'] as const;

export const OP_COUNT_PARAMS = ['query'] as const;

export const OP_COUNT_POST_PARAMS = [...OP_COUNT_PARAMS, 'queryListVariables'] as const;

export const OP_DELETE_PARAMS = ['populate', 'query'] as const;

export const OP_DISTINCT_PARAMS = ['query', 'distinct'] as const;
